// extracted by mini-css-extract-plugin
module.exports = {"filters":"price-history_filters__hMQCn","table":"price-history_table__PTri8"};